import { inject, Injectable } from '@angular/core';
import { ReportRequestBodyStrategy } from '../interfaces';
import { VerificationRequestBodyStrategy } from './mm-reports';

@Injectable({ providedIn: 'root' })
export class ReportStrategyFactory {
  private strategies: { [reportKey: string]: ReportRequestBodyStrategy } = {};

  mmVerificationStrategy = inject(VerificationRequestBodyStrategy);

  constructor() {
    this.strategies['mm_verification_report'] = this.mmVerificationStrategy;
  }

  getStrategy(reportKey: string): ReportRequestBodyStrategy {
    return this.strategies[reportKey];
  }
}
